export const convertAndFormatDate = (dateString: string): string => {
  if (isNaN(Date.parse(dateString))) {
    return '';
  }

  const date = new Date(dateString);

  return `${date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  })} ${date.toLocaleTimeString('en-GB').substring(0, 5)}`;
};

// Returns the number of days since the date passed as argument
export const daysAfter = (dateString: string): number | undefined => {
  if (isNaN(Date.parse(dateString))) {
    return undefined;
  }

  const date = new Date(dateString);
  const now = new Date();

  const diffDays = daysDifference(now, date);

  return diffDays < 0 ? undefined : diffDays;
};

export const daysDifference = (now: Date, date: Date): number => {
  const diffTime = now.getTime() - date.getTime();

  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
};

export const beginningOfDay = (date: Date) => {
  const day = new Date(date.getTime());

  day.setHours(0, 0, 0);

  return day;
};

export const endOfDay = (date: Date) => {
  const day = new Date(date);

  day.setHours(23, 59, 59);

  return day;
};
